const _version = "2.5.3"
function version() {
    return _version;
}
export default version
